import React from "react";
import "./Utility.sass";
import stake from "./../../../assets/images/stake.png";
import uncle from "./../../../assets/images/uncle.png";
import mint from "./../../../assets/images/mint.png";
import casino from "./../../../assets/images/casino.png";
import auction from "./../../../assets/images/auction.png";
import stars from "./../../../assets/images/stars.png";

export default function Utility() {
  return (
    <div className="utility">
      <div className="utility-bg">
        <div className="utility-container">
          <div className="utility-title">
            <div className="utility-line-1"></div>
            <h2>UTILITY</h2>
            <div className="utility-line-2"></div>
          </div>
          <div className="utility-items">
            <div className="utility-stake">
              <div className="stake-images">
                <div className="stake-stars">
                  <img src={stars} alt="stars" />
                </div>
                <div className="stake-image">
                  <img src={stake} alt="stake" />
                </div>
              </div>
              <div className="stake-text">
                <h3 className="stake-title">STAKE</h3>
                <p className="stake-description">
                  Frens that display their belief in Kek by pledging loyalty are
                  rewarded every FrenlyFriday with TENDIES
                </p>
              </div>
            </div>
            <div className="utility-uncle">
              <div className="uncle-image">
                <img src={uncle} alt="uncle" />
              </div>
              <div className="uncle-text">
                <h3 className="uncle-title">UNCLE ELON’S DREAM MACHINE</h3>
                <p className="uncle-description">
                  <strong>degENGINE :</strong> Spend you TENDIES for a Mystery
                  Box <strong>frENGINE :</strong>
                  Combine CRYSTALS with an Arc Reactor to build a CyberFren
                </p>
              </div>
            </div>

            <div className="utility-mint">
              <div className="mint-image">
                <img src={mint} alt="mint" />
              </div>
              <div className="mint-text">
                <h3 className="mint-title">MINT</h3>
                <p className="mint-description">
                  Participate in NFT mints for Good Boys Only! Yes, that’s
                  right! Mint with TENDIES
                </p>
              </div>
            </div>

            <div className="utility-auction">
              <div className="auction-image">
                <img src={auction} alt="auction" />
              </div>
              <div className="auction-text">
                <h3 className="auction-title">AUCTIONS</h3>
                <p className="auction-description">
                  Use your TENDIES to bid on exclusive NFT collections and items
                </p>
              </div>
            </div>

            <div className="utility-casino">
              <div className="casino-image">
                <img src={casino} alt="casino" />
              </div>
              <div className="casino-text">
                <h3 className="casino-title">CASINO</h3>
                <p className="casino-description">
                  Win BIG or Gamble all your TENDIES away like the Degen we all
                  know you are!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
